import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import { MQ, Spacing } from '@rover/kibble/styles';

const PageWrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  margin-top: 80px;
  margin-bottom: 160px;
  padding: 0 15px;

  ${MQ.LG.toString()} {
    width: 1170px;
  }

  ${MQ.MD.toString()} {
    width: 970px;
  }

  ${MQ.SM.toString()} {
    width: 750px;
  }

  ${MQ.XS.toString()} {
    width: 100%;
    padding: 0 ${Spacing.M.toString()};
  }
`;

export type Props = {
  children: ReactNode;
  style: any;
};

const PageLayout = ({ children, ...other }: Props): JSX.Element => (
  <PageWrapper {...other}>{children}</PageWrapper>
);

PageLayout.defaultProps = {
  style: {},
};

export default PageLayout;
